import { render, staticRenderFns } from "./ClientsArtists.vue?vue&type=template&id=5797dec4&scoped=true"
import script from "./ClientsArtists.vue?vue&type=script&lang=js"
export * from "./ClientsArtists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5797dec4",
  null
  
)

export default component.exports